import {BelegTileWidget} from "./widgets/beleg-tile";

export const widgets = {
  "unitrade:beleg-tile": BelegTileWidget,
};
